import React, { useMemo } from "react";
import useLeagueVocabulary from "../hooks/useLeagueVocabulary";

function unbeatenRun(form = []) {
  return form.reduce((total, result) => result === "L" ? total : total + 1, 0);
}

export default function AwardsPanel({ standings = [], fixtures = [] }) {
  const vocabulary = useLeagueVocabulary();
  const awards = useMemo(() => {
    if (!standings.length) return [];
    const completed = fixtures.filter((fixture) => fixture.status === "complete");
    const leader = standings[0];
    const mostWins = [...standings].sort((a, b) => Number(b.won || 0) - Number(a.won || 0))[0];
    const bestOperations = [...standings].sort((a, b) => Number(b.operationalPoints || 0) - Number(a.operationalPoints || 0))[0];
    const consistency = [...standings].sort((a, b) => unbeatenRun(b.form) - unbeatenRun(a.form))[0];
    const perfect = completed.find((fixture) => Number(fixture.homeScore) >= 3 && Number(fixture.awayScore) === 0) || completed.find((fixture) => Number(fixture.awayScore) >= 3 && Number(fixture.homeScore) === 0);
    const perfectClub = perfect ? (Number(perfect.homeScore) > Number(perfect.awayScore) ? perfect.homeClubName : perfect.awayClubName) : null;
    return [
      { icon: "♛", title: `${vocabulary.singular} of the Week`, club: leader?.name, detail: "Top of the live table" },
      { icon: "✦", title: "Performance Standard", club: mostWins?.name, detail: `${mostWins?.won || 0} top finishes this season` },
      { icon: "◈", title: "Operational Excellence", club: bestOperations?.name, detail: `${bestOperations?.operationalPoints || 0} operational points` },
      { icon: "∞", title: "Consistency Award", club: consistency?.name, detail: `${unbeatenRun(consistency?.form)} consistent results in recent form` },
      { icon: "★", title: "Perfect Performance", club: perfectClub || "Not awarded", detail: perfectClub ? "Delivered a standout result" : "No qualifying result yet" },
    ];
  }, [standings, fixtures]);

  return (
    <section className="league-panel league-awards-panel">
      <div className="league-panel-head"><div><p>Recognition</p><h2>League awards</h2></div><span>Calculated from live results</span></div>
      <div className="league-awards-grid">
        {awards.length ? awards.map((award) => <article key={award.title}><i>{award.icon}</i><span>{award.title}</span><strong>{award.club}</strong><small>{award.detail}</small></article>) : <div className="league-empty">Awards appear once {vocabulary.pluralLower} start competing.</div>}
      </div>
    </section>
  );
}
